import { of, Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { DiagnosticsVM, Teachers } from '../Elearning-Models';
import { IAPIService } from './API-Service/IAPIService';

export class DiagnosticsDataService {

  teachersList: Teachers;

  constructor(private APIService: IAPIService) {}

  getTeachersForAdmin = (): Observable<Teachers> => {
    if(this.teachersList) {
      return of(this.teachersList);
    } else {
      const response = this.APIService.GetTeachersForAdmin().pipe(map(response => {
        this.teachersList = response;
        return response;
        }
      ));
      return response;
    }
  }

  // getDiagnosticsDataForTeacher = (): Observable<DiagnosticsVM[]> => {
  //   return this.APIService.GetDiagnosticDataForTeacher();
  // }

}
